import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "externalLink"
const ExternalLinkIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.75 7.5H4.5V19.5H16.5V11.25H18V19.5L17.992 19.653C17.92 20.36 17.359 20.92 16.653 20.992L16.5 21H4.5C3.723 21 3.085 20.41 3.008 19.653L3 19.5V7.5C3 6.672 3.672 6 4.5 6H12.75z" />
          <path d="M21 10.5H19.5V5.56L8.78 16.28 7.72 15.22 18.44 4.5H13.5V3H21z" />
        </svg>
      }
    </span>
  )
}
export default ExternalLinkIcon
